import { AccomodationDto } from "./accomodation.dto";
export class AccomodationTranslationDto{
    detail?: string;
    locale?: string;
    accomodation?: AccomodationDto;
   constructor(
        detail?: string,
        locale?: string,
        accomodation?: AccomodationDto
    ){
        this.detail = detail;
        this.locale = locale;
        this.accomodation = accomodation
    }
}